import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import UserPermissions from "../../models/users/UserPermissions";
import { stateDeepCopy } from "../../helpers/DataUpdateHelper";

export interface PostGrestToken {
  exp: number;
  role: string;
  userid: number;
  display: string;
  jwt: string;
}

export const isValidPostgrestToken = (token: any): token is PostGrestToken => {
  let valid = false;
  try {
    valid =
      typeof token.exp === "number" &&
      typeof token.role === "string" &&
      typeof token.userid === "number" &&
      typeof token.display === "string" &&
      typeof token.jwt === "string";
  } catch (err: any) {
    /* empty */
  }
  return valid;
};

export interface AuthState {
  isLoggedIn: boolean;
  userDisplay: string;
  pgToken: string | null;
  permissions: UserPermissions;
}

// Normally, we would probaably initalize this empty and fetch data
// until API is finalized, use dummy data above
export const initialState: AuthState = {
  isLoggedIn: false,
  userDisplay: "",
  pgToken: null,
  permissions: stateDeepCopy(new UserPermissions(true)),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    updateSlice(state, action: PayloadAction<Partial<AuthState>>) {
      // Annoying bit of casting because WritatableDraft throws so many ts errors
      const stateData = state as unknown as AuthState;
      let key: keyof AuthState;

      for (key in action.payload) {
        (stateData[key] as any) = action.payload[key];
      }
      return stateData;
    },
    logIn(state, action: PayloadAction<PostGrestToken>) {
      state.isLoggedIn = true;
      state.userDisplay = action.payload.display;
      state.pgToken = action.payload.jwt;
      state.permissions = stateDeepCopy(new UserPermissions(true)); // just give them full access for now
    },
    logOut(state) {
      state.isLoggedIn = false;
      state.userDisplay = "";
      state.pgToken = null;
      state.permissions = stateDeepCopy(new UserPermissions(false)); // just remove all access for now
    },
  },
});

export const authSliceActions = authSlice.actions;
export default authSlice;
